import React from "react";
import ContentBelow from "../components/ContentBelow";
import Head from "../components/Head";
import background from "../images/services_background.png";
import SocialMediaPosts from "../components/SocialMediaPosts";

export default function SocialMedia() {
  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">Social Media</h2>
      </Head>
      <ContentBelow>
        <div className="container mt-4">
          <h2
            className="text-center"
            style={{ color: "#113358", fontWeight: "bold" }}
          >
            Do you Have FOMO - Fear of Missing Out ?
          </h2>
          <h5 style={{ color: "#113358" }} className="text-center">
            FOMO is real-especially if you're not following WeBridge! Missed our
            latest marketing posts? Don't worry,you can still catch up. Don't
            scroll past...all the cool people follow WeBridge
          </h5>
          <br />
          <SocialMediaPosts />
        </div>
      </ContentBelow>
    </>
  );
}
